import * as React from 'react';
import styled from 'styled-components';
import SmallHeader from './SmallHeader';
import SmallText from './SmallText';

const StepItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    margin-bottom: 32px;
  }
`;

interface props {
  image: string;
  title: string;
  detail: string;
}

const StepItem = (props: props) => {
  return (
    <StepItemContainer>
      <img src={props.image} alt="step-item-icon" />
      <SmallHeader>{props.title}</SmallHeader>
      <SmallText style={{ maxWidth: 350 }}>{props.detail}</SmallText>
    </StepItemContainer>
  );
};

export default StepItem;



// WEBPACK FOOTER //
// ./src/pages/LandingPage/components/StepItem.tsx